import { defineComponent, ref, inject } from 'vue';
import { useLocalizationSupport } from '../../../composables/localization-support/index.js';
import HoistComponent from '../../hoist-component/HoistComponent.vue.js';
import CloseButton from './CloseButton.vue.js';
import { portfolioTransactionAddFactory } from '../../portfolio-transaction-add/setup/index.js';
import { searchSuggesterFactory } from '../../search-suggester/setup/index.js';

var _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "PortfolioSuggestTransaction",
  props: {
    locale: { type: null, required: true },
    id: { type: null, required: true },
    suggesterProps: { type: null, required: false },
    portfolioStoreModule: { type: null, required: false }
  },
  emits: ["error", "close"],
  setup(__props, { emit: emits }) {
    var _a, _b;
    const props = __props;
    const securityId = ref(null);
    const onSelectResult = (item) => {
      securityId.value = item.id;
    };
    const onClose = () => {
      securityId.value = null;
      emits("close");
    };
    const onExchangeChange = (payload) => {
      securityId.value = payload == null ? void 0 : payload.id;
    };
    const onTransactionError = (errorBag) => {
      emits("error", errorBag);
    };
    const translator = inject("translator");
    const numberFormatter = inject("numberFormatter");
    const dateFormatter = inject("dateFormatter");
    const localizationSupport = useLocalizationSupport(props, { translator, numberFormatter, dateFormatter });
    const { translate } = localizationSupport;
    const PortfolioTransactionAdd = portfolioTransactionAddFactory({
      translator,
      numberFormatter,
      dateFormatter,
      storeModule: ((_a = props.portfolioStoreModule) == null ? void 0 : _a.getDependencies) ? props.portfolioStoreModule.getDependencies().portfolioTransactionAdd : void 0
    });
    const SearchSuggester = searchSuggesterFactory({
      translator,
      numberFormatter,
      dateFormatter,
      storeModule: ((_b = props.portfolioStoreModule) == null ? void 0 : _b.getDependencies) ? props.portfolioStoreModule.getDependencies().searchSuggester : void 0
    });
    return { __sfc: true, props, emits, securityId, onSelectResult, onClose, onExchangeChange, onTransactionError, translator, numberFormatter, dateFormatter, localizationSupport, translate, PortfolioTransactionAdd, SearchSuggester, HoistComponent, CloseButton };
  }
});

export { _sfc_main as default };
